





















































































import { Vue, Component, Prop } from 'vue-property-decorator';

import { objectIsEmpty } from '~/utils/common.js';

import RespectCard from '~/components/cards/RespectCard.vue';
import XSolid from '~/components/icons/XSolid.vue';

@Component({
  components: { RespectCard, XSolid },
})
export default class TouristCard extends Vue {
  @Prop(Object) provider: Types.TourismOffice;
  @Prop(Boolean) isInLocalisationContext: false;

  /* Computed skeleton handle */
  get providerIsEmpty () {
    return objectIsEmpty(this.provider);
  }

  /* Image fallback if card <img @error> is triggered */
  imageFallback (event: any) {
    event.target.src = "/img/placeholders/provider-placeholder.png";
  }
}
